.SelectorSwitch {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
}

.SelectorSwitch__options {
    display: flex;
    gap: 6px;
}

.SelectorSwitch__option {
    font-family: var(--soniq-t--global--font--family--mono);
    font-size: var(--soniq-t--global--font--size--field-label);
    letter-spacing: var(--soniq-t--global--font--letter-spacing--wide);
    text-transform: uppercase;
    color: var(--soniq-t--global--text--color--secondary--default);
    background: transparent;
    border: 1px solid var(--soniq-t--global--border--color--input--default);
    border-radius: 999px;
    padding: 5px 14px;
    cursor: pointer;
    transition: color 120ms ease, background 120ms ease, border-color 120ms ease;

    &:hover {
        background: var(--soniq-t--global--background--color--surface--hover);
    }

    &:focus-visible {
        outline: 2px solid var(--soniq-t--global--border--color--accent--today--default);
        outline-offset: 2px;
    }

    &.isActive {
        color: var(--soniq-t--global--text--color--brand--default);
        background: var(--soniq-t--global--background--color--accent--nav--default);
        border-color: var(--soniq-t--global--border--color--accent--active--default);
    }
}

.SelectorSwitch__label {
    font-size: var(--soniq-t--global--font--size--field-label);
    font-weight: var(--soniq-t--global--font--weight--medium);
    letter-spacing: var(--soniq-t--global--font--letter-spacing--wide);
    text-transform: uppercase;
    color: var(--soniq-t--global--text--color--label--default);
}

@media (prefers-reduced-motion: reduce) {
    .SelectorSwitch__option {
        transition: none;
    }
}
